<template>
  <Redirect :url="url" :tiempoEspera="tiempoEspera" />
</template>

<script>
import Redirect from '@/components/Redirect'
import { mapMutations } from 'vuex'

export default {
  name: 'Webmail',
  data () {
    return {
      url: process.env.VUE_APP_URL_WEBMAIL,
      tiempoEspera: 2000
    }
  },
  mounted () {
    this.hideNavAndFooter()
  },
  methods: {
    ...mapMutations(['hideNavAndFooter', 'showNavAndFooter'])
  },
  components: {
    Redirect
  },
  beforeDestroy () {
    this.showNavAndFooter()
  }
}
</script>
